(function () {
  'use strict';

  var CONFIG_ID = 'PawZapBundleGuardConfig';
  var CHECKOUT_SELECTOR =
    'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout';
  var CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/;

  var configElement = document.getElementById(CONFIG_ID);
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('[PawZap Bundle Guard] Invalid configuration.', error);
    return;
  }

  var mainProductId = String(config.mainProductId || '');
  var giftRules = (config.gifts || [])
    .map(function (gift) {
      return {
        key: gift.key,
        handle: gift.handle,
        variantId: String(gift.variantId || ''),
      };
    })
    .filter(function (gift) {
      return gift.variantId;
    });

  if (!mainProductId || giftRules.length !== 3) {
    console.error('[PawZap Bundle Guard] Required product IDs are missing.');
    document.documentElement.classList.add('pawzap-bundle-cart-invalid');
    return;
  }

  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve();
  var checkoutBypass = false;
  var busyCount = 0;

  function route(path) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    root = root.charAt(root.length - 1) === '/' ? root : root + '/';
    return root + path.replace(/^\//, '');
  }

  function cartJsonUrl() {
    return route('cart.js');
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || route('cart/update.js');
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || route('cart/add.js');
  }

  function cartPageUrl() {
    return (window.routes && window.routes.cart_url) || route('cart');
  }

  function toQuantity(value) {
    var quantity = parseInt(value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
  }

  function expectedQuantities(mainQuantity) {
    var quantity = toQuantity(mainQuantity);
    return {
      detangling: quantity,
      shipping: quantity,
      mystery: Math.max(quantity - 1, 0),
    };
  }

  function getMainQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return String(item.product_id) === mainProductId
        ? total + toQuantity(item.quantity)
        : total;
    }, 0);
  }

  function getGiftQuantity(cart, variantId) {
    return (cart.items || []).reduce(function (total, item) {
      return String(item.variant_id || item.id) === String(variantId)
        ? total + toQuantity(item.quantity)
        : total;
    }, 0);
  }

  function validateCart(cart) {
    var mainQuantity = getMainQuantity(cart);
    var expected = expectedQuantities(mainQuantity);

    return giftRules.every(function (gift) {
      return getGiftQuantity(cart, gift.variantId) === expected[gift.key];
    });
  }

  function buildPlan(cart) {
    var mainQuantity = getMainQuantity(cart);
    var expected = expectedQuantities(mainQuantity);
    var updates = {};
    var additions = [];

    giftRules.forEach(function (gift) {
      var desiredQuantity = expected[gift.key];
      var lines = (cart.items || []).filter(function (item) {
        return String(item.variant_id || item.id) === gift.variantId;
      });

      if (lines.length === 0 && desiredQuantity > 0) {
        additions.push({
          id: gift.variantId,
          quantity: desiredQuantity,
          properties: {
            _pawzap_bundle_item: gift.key,
          },
        });
        return;
      }

      lines.forEach(function (item, index) {
        var nextQuantity = index === 0 ? desiredQuantity : 0;
        if (toQuantity(item.quantity) !== nextQuantity) {
          updates[item.key || String(item.variant_id || item.id)] = nextQuantity;
        }
      });
    });

    return {
      mainQuantity: mainQuantity,
      expected: expected,
      updates: updates,
      additions: additions,
      changed: Object.keys(updates).length > 0 || additions.length > 0,
    };
  }

  function normalizeSections(value) {
    var sections = value;

    if (!sections) return [];
    if (typeof sections === 'string') {
      try {
        var parsed = JSON.parse(sections);
        sections = Array.isArray(parsed) ? parsed : sections.split(',');
      } catch (error) {
        sections = sections.split(',');
      }
    }

    if (!Array.isArray(sections)) sections = [sections];

    return sections
      .map(function (section) {
        return String(section).trim();
      })
      .filter(Boolean)
      .filter(function (section, index, list) {
        return list.indexOf(section) === index;
      })
      .slice(0, 5);
  }

  function requestContext(body) {
    var sections;
    var sectionsUrl;

    if (body instanceof FormData || body instanceof URLSearchParams) {
      sections = body.get('sections');
      sectionsUrl = body.get('sections_url');
    } else if (typeof body === 'string' && body) {
      try {
        var parsed = JSON.parse(body);
        sections = parsed.sections;
        sectionsUrl = parsed.sections_url;
      } catch (error) {
        sections = null;
      }
    }

    return {
      sections: normalizeSections(sections),
      sectionsUrl: sectionsUrl || window.location.pathname,
    };
  }

  function cartMutation(input) {
    try {
      var source = typeof input === 'string' ? input : input.url;
      var url = new URL(source, window.location.origin);
      return url.origin === window.location.origin && CART_MUTATION_PATTERN.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function setBusy(isBusy) {
    busyCount = Math.max(0, busyCount + (isBusy ? 1 : -1));
    document.documentElement.classList.toggle('pawzap-bundle-guard-busy', busyCount > 0);
    document.documentElement.setAttribute('data-pawzap-bundle-busy', busyCount > 0 ? 'true' : 'false');
  }

  function setCartValidity(isValid) {
    document.documentElement.classList.toggle('pawzap-bundle-cart-invalid', !isValid);
    document.documentElement.setAttribute('data-pawzap-bundle-valid', isValid ? 'true' : 'false');
  }

  function showMessage(message) {
    var existing = document.getElementById('PawZapBundleGuardMessage');
    if (!existing) {
      existing = document.createElement('div');
      existing.id = 'PawZapBundleGuardMessage';
      existing.className = 'pawzap-bundle-guard-message';
      existing.setAttribute('role', 'alert');

      var checkout = document.querySelector(CHECKOUT_SELECTOR);
      if (checkout && checkout.parentNode) {
        checkout.parentNode.insertBefore(existing, checkout);
      } else {
        document.body.appendChild(existing);
      }
    }
    existing.textContent = message;
  }

  function clearMessage() {
    var message = document.getElementById('PawZapBundleGuardMessage');
    if (message) message.remove();
  }

  async function fetchCart() {
    var response = await nativeFetch(cartJsonUrl(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) throw new Error('Unable to read the cart.');
    return response.json();
  }

  async function postCart(url, payload) {
    var response = await nativeFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    });

    var data;
    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Unable to update the bundle.');
    }
    return data;
  }

  async function fetchSections(sectionIds) {
    if (!sectionIds.length) return {};

    var url = new URL(cartPageUrl(), window.location.origin);
    url.searchParams.set('sections', sectionIds.join(','));
    var response = await nativeFetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) return {};
    try {
      return await response.json();
    } catch (error) {
      return {};
    }
  }

  async function synchronize(context) {
    context = context || { sections: [], sectionsUrl: window.location.pathname };
    context.sections = normalizeSections(context.sections);
    context.sectionsUrl = context.sectionsUrl || window.location.pathname;

    var cart = await fetchCart();
    var plan = buildPlan(cart);
    var renderedSections = {};

    if (Object.keys(plan.updates).length) {
      var updatePayload = {
        updates: plan.updates,
      };
      if (context.sections.length) {
        updatePayload.sections = context.sections;
        updatePayload.sections_url = context.sectionsUrl;
      }
      var updateResult = await postCart(cartUpdateUrl(), updatePayload);
      Object.assign(renderedSections, updateResult.sections || {});
    }

    if (plan.additions.length) {
      var addPayload = {
        items: plan.additions,
      };
      if (context.sections.length) {
        addPayload.sections = context.sections;
        addPayload.sections_url = context.sectionsUrl;
      }
      var addResult = await postCart(cartAddUrl(), addPayload);
      Object.assign(renderedSections, addResult.sections || {});
    }

    var finalCart = plan.changed ? await fetchCart() : cart;
    var valid = validateCart(finalCart);
    setCartValidity(valid);

    if (!valid) throw new Error('Bundle quantities do not match the main product.');

    if (plan.changed && context.sections.length) {
      var missingSections = context.sections.filter(function (section) {
        return !renderedSections[section];
      });
      if (missingSections.length) {
        Object.assign(renderedSections, await fetchSections(missingSections));
      }
    }

    var payload = Object.assign({}, finalCart);
    if (context.sections.length) payload.sections = renderedSections;

    document.dispatchEvent(
      new CustomEvent('pawzap:bundle-synced', {
        detail: {
          changed: plan.changed,
          mainQuantity: plan.mainQuantity,
          expected: plan.expected,
        },
      })
    );

    return {
      changed: plan.changed,
      cart: finalCart,
      plan: plan,
      payload: payload,
    };
  }

  function enqueue(context) {
    queue = queue.catch(function () {}).then(function () {
      return synchronize(context);
    });
    return queue;
  }

  function jsonResponse(payload) {
    return new Response(JSON.stringify(payload), {
      status: 200,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    });
  }

  window.fetch = async function guardedFetch(input, init) {
    if (!cartMutation(input)) return nativeFetch(input, init);

    setBusy(true);
    try {
      var response = await nativeFetch(input, init);
      if (!response.ok) return response;

      var result = await enqueue(requestContext(init && init.body));
      return result.changed ? jsonResponse(result.payload) : response;
    } catch (error) {
      setCartValidity(false);
      console.error('[PawZap Bundle Guard] Cart synchronization failed.', error);
      throw error;
    } finally {
      setBusy(false);
    }
  };

  function exactGiftItems(quantity) {
    var expected = expectedQuantities(quantity);
    var items = [];

    giftRules.forEach(function (gift) {
      for (var index = 0; index < expected[gift.key]; index += 1) {
        items.push(gift.variantId);
      }
    });
    return items;
  }

  function patchQuantityGifts() {
    if (!window.customElements || !window.customElements.whenDefined) return;

    window.customElements.whenDefined('quantity-gifts').then(function () {
      var QuantityGifts = window.customElements.get('quantity-gifts');
      if (!QuantityGifts || !QuantityGifts.prototype.unlockGifts) return;
      if (QuantityGifts.prototype.unlockGifts.pawzapBundleGuard) return;

      var originalUnlockGifts = QuantityGifts.prototype.unlockGifts;
      var guardedUnlockGifts = function (quantity) {
        originalUnlockGifts.call(this, quantity);
        if (this.dataset.mainProduct === config.mainProductHandle) {
          this.unlockedItems = exactGiftItems(quantity);
        }
      };
      guardedUnlockGifts.pawzapBundleGuard = true;
      QuantityGifts.prototype.unlockGifts = guardedUnlockGifts;

      document.querySelectorAll('quantity-gifts').forEach(function (element) {
        if (element.dataset.mainProduct !== config.mainProductHandle) return;

        var quantity = 1;
        var quantityBreaks = document.getElementById('quantity-breaks-' + element.dataset.section);
        var quantityInput = document.querySelector(
          '#Quantity-Form-' + element.dataset.section + ' input[name="quantity"]'
        );

        if (quantityBreaks && quantityBreaks.selectedQuantity) {
          quantity = quantityBreaks.selectedQuantity;
        } else if (quantityInput) {
          quantity = quantityInput.value;
        }
        element.unlockGifts(quantity);
      });
    });
  }

  async function continueToCheckout(target) {
    setBusy(true);
    clearMessage();
    try {
      var result = await enqueue({ sections: [], sectionsUrl: window.location.pathname });
      if (!result.cart || toQuantity(result.cart.item_count) === 0) {
        showMessage(
          'Free bundle items require the 3-in-1 Electric Grooming Comb. Please add the main product before checkout.'
        );
        return;
      }

      if (!validateCart(result.cart)) {
        showMessage('Your bundle is still being updated. Please try checkout again.');
        return;
      }

      checkoutBypass = true;
      var checkoutUrl = route('checkout');
      if (target && target.tagName === 'A' && target.href) checkoutUrl = target.href;
      window.location.assign(checkoutUrl);
    } catch (error) {
      setCartValidity(false);
      showMessage('We could not verify your bundle. Please refresh the page and try again.');
      console.error('[PawZap Bundle Guard] Checkout validation failed.', error);
    } finally {
      setBusy(false);
    }
  }

  function installCheckoutGuard() {
    document.addEventListener(
      'click',
      function (event) {
        if (checkoutBypass) return;
        var target = event.target.closest && event.target.closest(CHECKOUT_SELECTOR);
        if (!target) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        continueToCheckout(target);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (checkoutBypass) return;
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        continueToCheckout(submitter);
      },
      true
    );
  }

  function installStyles() {
    var handles = giftRules.map(function (gift) {
      return gift.handle;
    });
    var quantitySelectors = handles.map(function (handle) {
      return '.cart-item--product-' + handle + ' .quantity';
    });
    var removeSelectors = handles.map(function (handle) {
      return '.cart-item--product-' + handle + ' cart-remove-button';
    });
    var style = document.createElement('style');
    style.id = 'PawZapBundleGuardStyles';
    style.textContent =
      quantitySelectors.concat(removeSelectors).join(',') +
      '{display:none!important;}' +
      'html.pawzap-bundle-guard-busy ' +
      CHECKOUT_SELECTOR.replace(/, /g, ',html.pawzap-bundle-guard-busy ') +
      '{pointer-events:none!important;opacity:.55!important;}' +
      'html.pawzap-bundle-guard-busy .additional-checkout-buttons{pointer-events:none!important;opacity:.55!important;}' +
      'html.pawzap-bundle-cart-invalid ' +
      CHECKOUT_SELECTOR.replace(/, /g, ',html.pawzap-bundle-cart-invalid ') +
      ',html.pawzap-bundle-cart-invalid .additional-checkout-buttons{display:none!important;}' +
      '.pawzap-bundle-guard-message{margin:0 0 1rem;padding:1rem;border-radius:.6rem;background:#fff3cd;color:#664d03;font-size:1.3rem;line-height:1.4;}';
    document.head.appendChild(style);
  }

  function initialSync() {
    setBusy(true);
    enqueue({ sections: [], sectionsUrl: window.location.pathname })
      .then(function (result) {
        if (result.changed) window.location.reload();
      })
      .catch(function (error) {
        setCartValidity(false);
        console.error('[PawZap Bundle Guard] Initial cart check failed.', error);
      })
      .finally(function () {
        setBusy(false);
      });
  }

  installStyles();
  patchQuantityGifts();
  installCheckoutGuard();

  window.PawZapBundleGuard = {
    synchronize: function () {
      return enqueue({ sections: [], sectionsUrl: window.location.pathname });
    },
    validateCart: validateCart,
    expectedQuantities: expectedQuantities,
    buildPlan: buildPlan,
    config: config,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync, { once: true });
  } else {
    initialSync();
  }
})();
